import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import ConferenceForm from 'views/admin/conference/ConferenceForm'

const MyConference = () => {
  const { path } = useRouteMatch()
  const user = useSelector((state) => state.auth.user)

  return (
    <>
      <Switch>
        <Route exact path={`${path}/:conferenceId`}>
          <ConferenceForm />
        </Route>
        <Redirect to={`${path}/${user.conferenceId}`} />
      </Switch>
    </>
  )
}

export default MyConference
